"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichContentMedia = void 0;
const react_1 = __importDefault(require("react"));
const urlPrefix = 'https://m.media-amazon.com/images/I';
const RichContentMedia = ({ children }) => {
    const imageUrl = `${urlPrefix}/${children.content.physicalId}.${children.content.extension}`;
    const altText = children.supportText;
    const imgHeight = children.content.height;
    const imgWidth = children.content.width;
    return react_1.default.createElement("img", { "data-cy": "media", src: imageUrl, alt: altText, height: imgHeight, width: imgWidth });
};
exports.RichContentMedia = RichContentMedia;
